import { type MouseEvent } from "react";
import { FaGripLines } from "react-icons/fa";
import { Group, type GroupProps, Panel, type PanelProps, Separator, type SeparatorProps } from "react-resizable-panels";
import useIsDesktop from "@/hooks/viewports/use-is-desktop.ts";

// * TL;DR;
// * Resizing is only available on mobile viewports

export function ResizerGroup(props: GroupProps) {
    const isDesktop = useIsDesktop();

    return <Group {...props} disabled={isDesktop} orientation={isDesktop ? "horizontal" : "vertical"} />;
}

export function ResizerPanel(props: PanelProps) {
    return <Panel {...props} />;
}

export function ResizerSeparator(props: SeparatorProps) {
    const handleContextMenu = (evt: MouseEvent<HTMLDivElement>) => {
        evt.preventDefault(); // Disable long-press behaviour. Just make it act like a normal press
    };

    return <Separator {...props} onContextMenu={handleContextMenu} />;
}

export function ResizerHandle() {
    return (
        <div className="resizer">
            <button className="resizer__handle">
                <FaGripLines />
            </button>
        </div>
    );
}
